import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { GetSubPlans } from "../../apis/user/get_sub_plan";
import HeaderMenu from "../sidebar/headermenu";
import { GetUserPosts } from "../../apis/posts/get_user_post";
import { BoostProfileApi } from "../../apis/user/boost_profile_api";
import { GetPaymentOrderId } from "../../apis/user/get_payment_orderid";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import { GetBootPlans } from "../../apis/user/get_boot_plans";
import { BoostMargin } from "../../apis/user/boost_margin";

export default function BoostProfile() {
    const navigate = useNavigate();

    const [planStatus, setPlanStatus] = useState(API_STATUS);
    const [ApiStatus, setApiStatus] = useState(API_STATUS);
    const [PlanData, setPlanData] = useState([]);
    const [selected, setSelected] = useState('2');
    const [approve, setApprove] = useState(false);
    const [approveErr, setApproveErr] = useState(false);
    const [selPlan, setSelPlan] = useState('');
    const [errorMsg, setError] = useState('');
    const [amount, setAmount] = useState(0);
    const [bamount, setbAmount] = useState(0);
    const [loginId, setLoginId] = useState("");
    const [userData, setUserData] = useState('');

    const [fileData, setFileData] = useState([]);
    const [getFileApi, setGetFileApi] = useState(API_STATUS);
    const [noFile, setNofile] = useState(false);
    const [selPhoto, setSelPhoto] = useState('');
    const [PayApi, setPayApi] = useState(API_STATUS);

    const { error, isLoading, Razorpay } = useRazorpay();


    useEffect(() => {
        if (!getFileApi.isError && !getFileApi.isLoader && getFileApi.data != null) {
            let res = getFileApi.data;
            if (res['status'] === 1) {
                setFileData(res['data']);
            } else {
                setNofile(true);
            }
        }
    }, [getFileApi]);

    useEffect(() => {
        if (!ApiStatus.isError && !ApiStatus.isLoader && ApiStatus.data != null) {
            let res = ApiStatus.data;
            if (res['status'] === 1) {
                BoostMargin(res['data']);
                navigate('/');
            }
        }
    }, [ApiStatus]);

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);
            const loginData = sessionStorage.getItem('LOGIN_DATA');
            if (loginData !== null) {
                const udata = JSON.parse(loginData);
                setUserData(udata);
            }

            GetUserPosts(userCode, 'image', setGetFileApi);
        }
    }, []);

    useEffect(() => {
        GetBootPlans(setPlanStatus);
    }, []);

    useEffect(() => {
        if (!planStatus.isError && !planStatus.isLoader && planStatus.data != null) {
            const res = planStatus.data;
            console.log(res);
            if (res['status'] === 1) {
                setPlanData(res.data);
                setSelected(res.data[0].id);
                setbAmount(0);
                setAmount(parseInt(res.data[0].amount));
                setSelPlan({ 'planId': res.data[0].id, 'amount': res.data[0].amount, 'plan': res.data[0].title });
            }
        }
    }, [planStatus]);

    useEffect(() => {

        if (!PayApi.isError && !PayApi.isLoader && PayApi.data != null) {
            var res = PayApi.data;
            if (res.status === 1) {
                makePayment({ 'amount': parseInt(selPlan['amount']) + parseInt(bamount), 'order_id': res.order_id });
            }
        }
    }, [PayApi]);

    const makePayment = (data) => {

        const options = RazorpayOrderOptions = {
            key: "rzp_test_BKvWBTGpzXmQhm",
            amount: data['amount'] * 100, // Amount in paise
            currency: "INR",
            name: "Filmwings",
            description: "Boost Profile",// Generate order_id on server
            handler: (response) => {
                if (response['razorpay_payment_id'] !== null) {
                    submitData(response);
                }
            },
            prefill: {
                name: userData['firstName'],
                email: userData['email'],
                contact: userData['mobile'],
            },
            theme: {
                color: "#F37254",
            },
        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();

    }

    const getPayId = () => {
        makePayment({ 'amount': parseInt(selPlan['amount']) + parseInt(bamount), 'order_id': '' });

        // setApiStatus({ isLoader: true, isError: false, data: null });
        // const body = {
        //     'total': parseInt(selPlan['amount']),
        // };

        // GetPaymentOrderId(body, setPayApi);
    }

    const submitData = (res) => {
        const body = {
            'total': parseInt(selPlan['amount']),
            'photo': selPhoto,
            'period': '90 Days'
        };
        body['payMethod'] = 'Razorpay';
        body['payId'] = res['razorpay_payment_id'];
        body['payRef'] = res['razorpay_order_id'];

        BoostProfileApi(body, setApiStatus);
    }



    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-2xl mx-auto px-1 py-1">
                <div class="page__heading py-6 mt-6">
                    <Link
                        onClick={() => navigate(-1)}
                    >
                        <ion-icon name="chevron-back-outline"></ion-icon> Back
                    </Link>
                    <h1> Boost Profile </h1>
                </div>

                <div class="max-w-2x flex-1 relative">
                    <div>
                        <h3 class="md:text-xl text-base font-semibold text-black dark:text-white"> What is profile booster ? </h3>
                        <p className="text-sm mt-2 md:font-normal font-light">The profile Booster is a
                            feature offered by Filmwings. When users opt for the
                            booster plan, they can advertise their profiles within the
                            Filmwings application. This facilitates increased visibility
                            of the user's account among technicians and media
                            channels on a frequent basis throughout the validity
                            period.</p>
                    </div>
                    <div className="flex mt-2">
                        {
                            planStatus.isLoader &&
                            <div role="status" style={{ justifyItems: 'center', alignContent: 'center' }}>
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        }
                        {
                            PlanData.map((items) =>
                                <div key={items.id}>
                                    {
                                        selected === items.id && items.id === 5 &&
                                        <button className="button bg-white border text-left" style={{ borderWidth: 2, borderColor: "#7ccd7c", minWidth: 250 }}>
                                            <p>{items.title}</p>
                                            <h3 className="sm:text-xl sm:font-bold mt-1 text-green-600 dark:text-white text-base font-normal">Rs. {items.amount}</h3>
                                        </button>
                                    }
                                </div>
                            )
                        }

                    </div>


                    <div className="mt-5">
                        <h3 class="md:text-xl text-base font-semibold text-black dark:text-white">Total Amount : {amount}.00 </h3>
                    </div>



                    <div className="mt-2">
                        <h3 class="md:text-xl text-base font-semibold text-black dark:text-white"> Select Photo </h3>
                        {
                            errorMsg !== '' &&
                            <div className="py-5 text-red-500">Select one photo for profile promotion</div>
                        }
                        {
                            fileData.length > 0 &&
                            <div className="flex">
                                {
                                    fileData.map((item, i) =>
                                        <div
                                            onClick={() => {
                                                setSelPhoto(item.path);
                                                setError('');
                                            }}
                                            className="p-1 w-100 relative cursor-pointer" style={{ height: 150 }}>
                                            <img src={item.path} className="rounded-lg w-full h-full object-cover inset-0" />
                                            {
                                                selPhoto === item.path &&
                                                <div className="item-center p-2 text-lg text-blue-600 absolute left-0 right-0 top-0 bottom-0" style={{ backgroundColor: '#ffffffd1' }}>
                                                    <i class="fa fa-check-circle-o"></i>
                                                </div>
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        }
                    </div>

                    {
                        PlanData !== null && PlanData.length > 0 &&

                        <div className="flex items-center justify-center gap-4 mt-10 mb-10">
                            <button
                                onClick={() => {
                                    if (selPhoto === "") {
                                        setError('error');
                                    } else {
                                        getPayId();
                                    }
                                }}
                                type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Confirm <span className="ripple-overlay"></span></button>
                        </div>
                    }
                    {
                        ApiStatus.isLoader &&
                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    }
                </div>
            </div>
        </main>
    </div>
}